import firebase from 'firebase/app';
require('firebase/auth')
import Vue from 'vue';
import App from './App.vue';
import Vuex from 'vuex';
import router from "./router";
import store from './store.js';
import VuejsDialog from 'vuejs-dialog';
//import 'vuejs-dialog/dist/vuejs-dialog.min.css';

Vue.use(VuejsDialog);

Vue.config.productionTip = false

Vue.use(Vuex)

let app = '';

firebase.initializeApp({
  apiKey: "AIzaSyDBDCpDz6CsGHUpXaVqiV6VwOKxelo_QUE",
  authDomain: "powered-by-polymer.firebaseapp.com",
  databaseURL: "https://powered-by-polymer.firebaseio.com",
  projectId: "powered-by-polymer",
  storageBucket: "powered-by-polymer.appspot.com",
  messagingSenderId: "292130793877",
  appId: "1:292130793877:web:2bffcc2c87a42300d1ee9c",
  measurementId: "G-RT8L5WT8MK"
});

export const db = firebase.firestore()
//window.firebase = firebase;

firebase.auth().onAuthStateChanged( () => {
  if (!app) {
    store.dispatch("checkUser").then(()=>{
      app = new Vue({
        store,
        router,
        render: h => h(App),
      }).$mount('#app')
    })
  }
})
